import { render, staticRenderFns } from "./merchantAutoSweepPaymentComponent.vue?vue&type=template&id=1544b63f&"
import script from "./merchantAutoSweepPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./merchantAutoSweepPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports